import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { ProductRepositoryImpl } from "../../domain/productRepositoryImpl/ProductRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const productRepository = ProductRepositoryImpl.getInstance();

const useGetBenefitMediaUrlByVariantId = (variantId: string) => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { data } = useQuery(
    {
      queryKey: ["useGetBenefitMediaUrlByVariantId", auth, variantId],
      queryFn: async () => {
        const response = await productRepository.getBenefitsMediaUrl(variantId, auth, apiUrl);
        return response;
      },
      enabled: Boolean(auth) && Boolean(variantId),
    },
    queryClient,
  );

  return data;
};

export { useGetBenefitMediaUrlByVariantId };
